/**
 * Цветовая схема для 13 категорий анализов
 * Каждая категория имеет уникальный цвет для визуального различения
 */

export const CATEGORY_COLORS = {
  'карьера': {
    bg: 'bg-blue-100',
    text: 'text-blue-700',
    border: 'border-blue-200',
    hover: 'hover:bg-blue-200'
  },
  'финансы': {
    bg: 'bg-purple-100',
    text: 'text-purple-700',
    border: 'border-purple-200',
    hover: 'hover:bg-purple-200'
  },
  'здоровье': {
    bg: 'bg-emerald-100',
    text: 'text-emerald-700',
    border: 'border-emerald-200',
    hover: 'hover:bg-emerald-200'
  },
  'отношения': {
    bg: 'bg-pink-100',
    text: 'text-pink-700',
    border: 'border-pink-200',
    hover: 'hover:bg-pink-200'
  },
  'образование': {
    bg: 'bg-indigo-100',
    text: 'text-indigo-700',
    border: 'border-indigo-200',
    hover: 'hover:bg-indigo-200'
  },
  'недвижимость': {
    bg: 'bg-amber-100',
    text: 'text-amber-700',
    border: 'border-amber-200',
    hover: 'hover:bg-amber-200'
  },
  'семья': {
    bg: 'bg-rose-100',
    text: 'text-rose-700',
    border: 'border-rose-200',
    hover: 'hover:bg-rose-200'
  },
  'развитие': {
    bg: 'bg-teal-100',
    text: 'text-teal-700',
    border: 'border-teal-200',
    hover: 'hover:bg-teal-200'
  },
  'покупки': {
    bg: 'bg-orange-100',
    text: 'text-orange-700',
    border: 'border-orange-200',
    hover: 'hover:bg-orange-200'
  },
  'путешествия': {
    bg: 'bg-cyan-100',
    text: 'text-cyan-700',
    border: 'border-cyan-200',
    hover: 'hover:bg-cyan-200'
  },
  'досуг': {
    bg: 'bg-lime-100',
    text: 'text-lime-700',
    border: 'border-lime-200',
    hover: 'hover:bg-lime-200'
  },
  'бизнес': {
    bg: 'bg-slate-100',
    text: 'text-slate-700',
    border: 'border-slate-200',
    hover: 'hover:bg-slate-200'
  },
  'другое': {
    bg: 'bg-gray-100',
    text: 'text-gray-700',
    border: 'border-gray-200',
    hover: 'hover:bg-gray-200'
  }
} as const;

export type CategoryKey = keyof typeof CATEGORY_COLORS;

/**
 * Получить цветовую схему для категории
 * @param category - название категории (в нижнем регистре из БД)
 * @returns объект с цветовыми классами или дефолтную схему
 */
export const getCategoryColors = (category: string | null | undefined) => {
  if (!category) {
    return {
      bg: 'bg-gray-100',
      text: 'text-gray-700',
      border: 'border-gray-200',
      hover: 'hover:bg-gray-200'
    };
  }

  // Прямое обращение к ключу в нижнем регистре
  return CATEGORY_COLORS[category as CategoryKey] || {
    bg: 'bg-gray-100',
    text: 'text-gray-700',
    border: 'border-gray-200',
    hover: 'hover:bg-gray-200'
  };
};

/**
 * Получить объединенные классы для категории
 * @param category - название категории
 * @returns строка с CSS классами
 */
export const getCategoryClasses = (category: string | null | undefined) => {
  const colors = getCategoryColors(category);
  return `${colors.bg} ${colors.text} ${colors.border}`;
};
